import { graphql } from '@shared/types/storefront'

graphql(/* GraphQL */ `
  fragment Cart on Cart {
    id
    buyerIdentity {
      countryCode
      email
      phone
    }
    checkoutUrl
    cost {
      ...CartCost
    }
    createdAt
    delivery {
      addresses {
        ...CartSelectableAddress
      }
    }
    discountAllocations {
      ...CartDiscountAllocation
    }
    discountCodes {
      ...CartDiscountCode
    }
    lines(first: 20) {
      items: nodes {
        ...CartLine
      }
    }
    deliveryGroups(first: 1) {
      items: nodes {
        ...CartDeliveryGroup
      }
    }
  }
`)

export const cartCreateQuery = graphql(/* GraphQL */ `
  mutation cartCreate(
    $input: CartInput
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartCreate(input: $input) {
      cart {
        ...Cart
      }
      userErrors {
        ...CartError
      }
      warnings {
        ...CartWarning
      }
    }
  }
`)

export const getCartQuery = graphql(/* GraphQL */ `
  query CartQuery($cartId: ID!, $country: CountryCode, $language: LanguageCode)
  @inContext(country: $country, language: $language) {
    cart(id: $cartId) {
      ...Cart
    }
  }
`)

export const addToCartQuery = graphql(/* GraphQL */ `
  mutation addToCart(
    $cartId: ID!
    $lines: [CartLineInput!]!
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ...Cart
      }
      userErrors {
        code
        field
        message
      }
      warnings {
        ...CartWarning
      }
    }
  }
`)

export const removeFromCartQuery = graphql(/* GraphQL */ `
  mutation removeFromCart(
    $cartId: ID!
    $lineIds: [ID!]!
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ...Cart
      }
      userErrors {
        code
        field
        message
      }
      warnings {
        ...CartWarning
      }
    }
  }
`)

export const updateCartLinesQuery = graphql(/* GraphQL */ `
  mutation cartLinesUpdate(
    $cartId: ID!
    $lines: [CartLineUpdateInput!]!
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ...Cart
      }
      userErrors {
        code
        field
        message
      }
      warnings {
        ...CartWarning
      }
    }
  }
`)
